import { DocumentNode, gql } from '@apollo/client';
import { Button, HStack } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { AnswerButton } from '@/components/AnswerButton';
import { usePostHref } from '@/hooks/usePostHref';

import { AnswerFooter_QuestionFragment } from './graphql-types/AnswerFooter_QuestionFragment';

const QUESTION_FRAGMENT = gql`
  fragment AnswerFooter_QuestionFragment on QuestionV2 {
    _id
    answerCount
    ...AnswerButton_QuestionFragment
  }
  ${AnswerButton.questionFragment}
`;

export const AnswerFooter: React.FC<{
  question: AnswerFooter_QuestionFragment;
  showSeeAllAnswers: boolean;
}> & {
  questionFragment: DocumentNode;
} = ({ question, showSeeAllAnswers }) => {
  const postHref = usePostHref(question._id);

  return showSeeAllAnswers ? (
    <HStack width="full">
      <AnswerButton w="full" question={question} />
      <NextLink href={postHref}>
        <Button w="full" variant="outline" colorScheme="gray">
          See All Answers ({question.answerCount})
        </Button>
      </NextLink>
    </HStack>
  ) : (
    <AnswerButton w="full" question={question} />
  );
};
AnswerFooter.questionFragment = QUESTION_FRAGMENT;
